/* Mobile bottom tab navigation — only renders on screens < lg.

   Five most-used destinations sit on the bottom rail; the remaining
   admin sections (Studios, Site Settings, Reviews, Waitlist, Services)
   stay accessible via the existing hamburger menu in the mobile topbar.

   This is what turns the PWA from "responsive website" into "app I added
   to my home screen" — the bottom tab bar is the single visual cue
   photographers read as "this is a real mobile app." */

import { NavLink } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Images, Users, Sparkles } from "lucide-react";

const TABS = [
  { to: "/admin", end: true, label: "Home", icon: LayoutDashboard, testid: "mtab-home" },
  { to: "/admin/bookings", label: "Bookings", icon: CalendarDays, testid: "mtab-bookings" },
  { to: "/admin/galleries", label: "Galleries", icon: Images, testid: "mtab-galleries" },
  { to: "/admin/customers", label: "Clients", icon: Users, testid: "mtab-clients" },
  // 5th tab is the AI Copilot — kept on the bar so mobile photographers
  // get one-tap access without the floating pill (which we hide on mobile).
  { to: "#copilot", label: "AI", icon: Sparkles, testid: "mtab-copilot", isCopilot: true },
];

export default function MobileTabBar({ onOpenCopilot }) {
  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0F0E0D]/95 backdrop-blur-xl border-t border-white/[0.08] pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-tab-bar"
      aria-label="Primary"
    >
      <ul className="flex items-stretch justify-around">
        {TABS.map((t) => (
          <li key={t.testid} className="flex-1">
            {t.isCopilot ? (
              <button
                type="button"
                onClick={onOpenCopilot}
                data-testid={t.testid}
                className="w-full h-14 flex flex-col items-center justify-center gap-0.5 text-stone-500 active:bg-white/[0.04] transition-colors"
                aria-label="Open AI Copilot"
              >
                <t.icon className="w-[18px] h-[18px] text-[#C9A961]" />
                <span className="text-[9.5px] uppercase tracking-[0.22em] text-[#C9A961] font-medium">
                  {t.label}
                </span>
              </button>
            ) : (
              <NavLink
                to={t.to}
                end={t.end}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `w-full h-14 flex flex-col items-center justify-center gap-0.5 transition-colors ${
                    isActive
                      ? "text-stone-100 bg-white/[0.04]"
                      : "text-stone-500 active:bg-white/[0.04]"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <t.icon
                      className="w-[18px] h-[18px]"
                      style={isActive ? { color: "#C9A961" } : {}}
                    />
                    <span
                      className={`text-[9.5px] uppercase tracking-[0.22em] font-medium ${
                        isActive ? "text-stone-100" : ""
                      }`}
                    >
                      {t.label}
                    </span>
                    {isActive && (
                      <span className="absolute top-0 h-0.5 w-8 bg-[#C9A961] rounded-b-sm" />
                    )}
                  </>
                )}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
